export default "/images/momentive.webp?5ff06436e1b21a869c119c6cfb223b52";